import { Grid } from '@mui/material'
import { HearingSummaryProps } from 'components/HearingSummary'
import { StyledSpan as Span } from 'components/HearingSummary/styles'
import { validateArrestedType } from 'components/HearingSummary/utils/validate-field.util'
import Label from 'components/Label'
import React from 'react'
import { HearingSummaryType } from 'types/hearing-summary.type'
import { isFilled, validateField } from 'utils/validate.util'
import { StyledBoxTerm, StyledLabelHeading as LabelHeading } from './styles'
import dayjs from 'dayjs'

export const Header: React.FC<HearingSummaryProps<HearingSummaryType>> = ({ data }) => {
  const { dadosGerais, identAdolescente } = data

  const space = `${' '}`
  const logoMinisterioPublico = '/img/logotipo_MP.png'
  const termHeaderText = 'TERMO DE OITIVA INFORMAL (ARTIGO 179 DA LEI Nº 8.069/90)'

  const hearingDateField = dadosGerais ? validateField(dadosGerais.dataOitiva) : ''
  const responsibleForField = dadosGerais
    ? validateField(dadosGerais.nomeResponsavelAdolescente)
    : ''
  const lawyerNameField = dadosGerais ? validateField(dadosGerais.nomeAdvogado) : ''
  const releasedField = dadosGerais ? validateArrestedType(dadosGerais.adolescenteApreendido) : ''
  const identificationName = isFilled(identAdolescente)
    ? isFilled(identAdolescente.nomeSocial)
      ? identAdolescente.nomeSocial
      : identAdolescente.nome
    : ''

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} display='flex' justifyContent='center' sx={{ mb: 1 }}>
        <img src={logoMinisterioPublico} />
      </Grid>
      <Grid item xs={12} display='flex' justifyContent='center' sx={{ mb: 1 }}>
        <StyledBoxTerm sx={{ display: 'flex', justifyContent: 'center' }}>
          <Label text={termHeaderText} sx={{ fontWeight: 'bold' }} />
        </StyledBoxTerm>
      </Grid>
      <Grid item xs={12} display='flex' justifyContent='center' sx={{ mb: 2 }}>
        <LabelHeading>
          No dia{' '}
          <Span fontWeight='bold'>
            {dayjs(hearingDateField).isValid()
              ? dayjs(hearingDateField).format('DD/MM/YYYY')
              : dayjs().format('DD/MM/YYYY')}
          </Span>
          , na forma do disposto no art. 179 da Lei 8069/90 Criança e do Adolescente, foi o(a)
          adolescente
          {space}
          <Span fontWeight='bold'>{identificationName}</Span>, acompanhado de seu responsável (ou
          Não){space}
          <Span fontWeight='bold'>{responsibleForField}</Span>, bem como seu advogado (ou Não)
          {space}
          <Span fontWeight='bold'>{lawyerNameField}</Span>, ou desacompanhado na qualidade de
          <Span fontWeight='bold'>
            {space}
            {releasedField}
            {space}
          </Span>
          e ouvido(a) informalmente pelo MINISTÉRIO PÚBLICO, através do Promotor de Justiça da
          Infância e da Juventude abaixo assinado, tendo declarado que:
        </LabelHeading>
      </Grid>
    </Grid>
  )
}
